// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3F_Rm","fileBtn":"File_fileBtn__USDpV","closeBtn":"File_closeBtn__2upGT","fileSelected":"File_fileSelected__20S9D","disabled":"File_disabled__1Lmms"};